export default {
  namespaced: true,
  state: {
    statusList: [
      {
        value: '待关联视频',
        color: '',
      },
      {
        value: '修改待复核',
        color: '',
      },
      {
        value: '待审核',
        color: '',
      },
      {
        value: '通过',
        color: '#67C23A',
      },
      {
        value: '拒绝',
        color: '#F56C6C',
      },
      {
        value: '待提交',
        color: '#666666',
      },
      {
        value: '需要修改',
        color: '',
      },
      {
        value: '修改待提交',
        color: '',
      },
    ],
    materialAndActionsStatusList: [
      {
        value: '',
        color: '',
      },
      {
        value: '待审核',
        color: '',
      },
      {
        value: '通过',
        color: '#67C23A',
      },
      {
        value: '拒绝',
        color: '#F56C6C',
      },
      {
        value: '待提交',
        color: '',
      },
    ],
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
  },
  actions: {},
  getters: {
    statusList: state => state.statusList,
    materialAndActionsStatusList: state => state.materialAndActionsStatusList,
  },
};
